import { SeoService } from './../../services/seo.service';
import { isPlatformBrowser } from '@angular/common';
import {
  afterNextRender,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  inject,
  PLATFORM_ID,
  signal,
  ViewEncapsulation,
  ChangeDetectionStrategy
} from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { SwiperOptions } from 'swiper/types';
import { SwiperDirective } from '../../directives/init-swiper';
import { ARTICLES } from '../../data/articles';
import { ContactSection } from '../../components/contact-section/contact-section';
import { createHomepageSchemas } from '../../data/structured-data';

@Component({
  selector: 'app-home',
  imports: [RouterModule, SwiperDirective, ContactSection],
  templateUrl: './home.html',
  styleUrl: './home.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.None,
})
export class Home {
  protected readonly isAnimated = signal(false);
  private platformId = inject(PLATFORM_ID);
  protected readonly articles = ARTICLES;

  private readonly seoService = inject(SeoService);
  protected readonly seoTitle = 'Mari Group – Powering Global Live Experiences';
  protected readonly seoDescription =
    'MARI is reshaping the live events landscape — delivering world-class experiences across sport, art, and lifestyle that move culture globally.';

  isBrowser = isPlatformBrowser(this.platformId);
  pressSwiperConfig: SwiperOptions = {
    loop: false,
    slidesPerView: 1.2,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    a11y: {
      id: 'articles',
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
      },
    },
  };

  constructor() {
    this.seoService.update({
      title: this.seoTitle,
      description: this.seoDescription,
      jsonLdBlocks: createHomepageSchemas(this.seoDescription),
    });

    afterNextRender(() => {
      if (isPlatformBrowser(this.platformId)) {
        setTimeout(() => {
          this.isAnimated.set(true);
        }, 150);
      }
    });
  }
}
